import { useMutation, useQueryClient } from "@tanstack/react-query";

import { translateDomainError } from "#app/i18n/translateApiError";
import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { layoutQuery } from "#modules/layouts/infra/layout.query";
import { updateLayout } from "#modules/layouts/infra/updateLayout.api";
import { isOptimizationInvalidationCancelled } from "#modules/optimizations/infra/optimizationInvalidationConfirmation";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { isDomainError } from "shared";

export const useUpdateLayout = (
  quoteRequestLineId: string | undefined,
  options?: { onError?: () => void },
) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateLayout,
    onSuccess: (_, variables) => {
      const { id } = variables;
      void queryClient.invalidateQueries(layoutQuery(id));

      if (quoteRequestLineId) {
        void queryClient.invalidateQueries(quoteRequestLineQuery({ id: quoteRequestLineId }));
      }
    },
    onError: (err) => {
      if (isOptimizationInvalidationCancelled(err)) {
        return;
      }

      if (isDomainError(err)) {
        showErrorToast({ title: translateDomainError(err) });
      } else {
        showErrorToast({ title: err.message });
      }
      errorHandler(err);
      options?.onError?.();
    },
  });

  return { updateLayout: mutate, ...rest };
};
